module.exports = __webpack_public_path__ + "static/media/logo.aa993a93.svg";